// extracted by mini-css-extract-plugin
export default {"sections":"terms-of-service_sections__h1zMj","subsections-list":"terms-of-service_subsections-list__dvqHa","subsections-sub-list":"terms-of-service_subsections-sub-list__5TVE0"};